<template>
  <div class="container">

    <heading-one class="-margin-md">口座のご登録</heading-one>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="2" type="entry"></main-wizard>
    </wizard-group>

    <notice-box class="-error _textleft">
      <notice-header>
        <h2 class="heading">ご指定の口座ではご登録することができませんでした。</h2>
      </notice-header>
      <notice-body>
        <list-group class="-normal">
          <list-item class="-normal">口座のご名義がご本人さまと異なっている</list-item>
          <list-item class="-normal">本サービスが対応していない金融機関</list-item>
        </list-group>
        <span>上記等はご利用することができません。誠に申し訳ございませんが、下記のボタンより再度ご本人さま確認をお願い致します。</span>
      </notice-body>
    </notice-box>

    <btngroup-single class="-margin-lg _mb-md-20 _mb-sm-20">
      <btn-main class="-main btn-1" routerName="en006" :query="{state: '2'}">別の口座を登録する</btn-main>
    </btngroup-single>

    <btngroup-single class="_mb-md-120 _mb-sm-60">
      <btn-main class="-main btn-2" routerName="en007">ご本人さま確認書類のご提出を行う</btn-main>
    </btngroup-single>
  </div>
</template>

<script>

import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import NoticeBody from '../components/box/NoticeBody'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
export default {
  name: 'Tem-004',
  metaInfo: {
    title: '口座のご登録',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,口座登録'}
    ]
  },
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeBody,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
    ListGroup,
    ListItem
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/stylesheets/styles";
.btn-main.btn-1 {
  @include mq-up(md) {
    font-size: 19px;
  }
}

.btn-main.btn-2 {
  @include mq-up(md) {
    font-size: 19px;
    padding-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Tem004.vue